import React, { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import mx from "./mx.json";
import en from "./en.json";

const DICTIONARIES = { mx, en };
const SUPPORTED = ["mx", "en"];
const DEFAULT_LOCALE = "mx";

const I18nContext = createContext({ locale: DEFAULT_LOCALE, t: (k) => k, dict: mx });

const getByPath = (obj, path) => {
  if (!path) return undefined;
  return path.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), obj);
};

export const I18nProvider = ({ children }) => {
  const params = useParams();
  const raw = (params.lang || DEFAULT_LOCALE).toLowerCase();
  const locale = SUPPORTED.includes(raw) ? raw : DEFAULT_LOCALE;
  const dict = DICTIONARIES[locale];

  const value = useMemo(() => {
    const t = (key, fallback = "") => {
      const val = getByPath(dict, key);
      if (val === undefined || val === null) return fallback || key;
      return val;
    };
    return { locale, dict, t };
  }, [locale, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
export const SUPPORTED_LOCALES = SUPPORTED;
export const DEFAULT_LOCALE_KEY = DEFAULT_LOCALE;
